<p-confirmDialog />
<div class="card">
  <div class="card-content">

    <!-- Stats cards -->
    <div class="stats-cards-row" *ngIf="!loading">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCount }}</span>
          <span class="stats-card-label">Total Cost Centers</span>
          <span class="stats-card-sublabel">Used during pursuit</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-wallet"></i></div>
      </div>
      <div class="stats-card stats-card--info">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ sharedCount }}</span>
          <span class="stats-card-label">Shared</span>
          <span class="stats-card-sublabel">Offered for every client</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-share-alt"></i></div>
      </div>
    </div>

    <!-- ============ Collapsible filter bar (driven by header filter icon) ============ -->
    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible"
         *ngIf="!loading">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label">Status</label>
          <p-select [(ngModel)]="selectedStatus" (ngModelChange)="applyFilters()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value"
            placeholder="All" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Presales Client</label>
          <p-select [(ngModel)]="selectedClientFilter" (ngModelChange)="applyFilters()"
            [options]="clientOptions" optionLabel="label" optionValue="value"
            placeholder="All clients" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- Table -->
    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredCostCenters"
      [loading]="loading"
      [paginator]="filteredCostCenters.length > 15"
      [alwaysShowPaginator]="false"
      [rows]="15"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} presales cost centers"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines presales-cost-centers-table">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">Cost Center <p-sortIcon field="name" /></th>
          <th pSortableColumn="presalesClientName" style="width: 220px;">Presales Client <p-sortIcon field="presalesClientName" /></th>
          <th pSortableColumn="serviceGroupName" style="width: 180px;">Service Group <p-sortIcon field="serviceGroupName" /></th>
          <th class="th-actions" style="width: 110px;">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-costCenter>
        <tr [class.row-inactive]="costCenter.isActive === false">
          <td>
            <div class="cc-name-cell">
              <span class="cc-name">{{ costCenter.name }}</span>
              <span class="cc-description" *ngIf="costCenter.description">{{ costCenter.description }}</span>
            </div>
          </td>
          <td>
            <span class="client-pill" *ngIf="costCenter.presalesClientName">{{ costCenter.presalesClientName }}</span>
            <span class="shared-pill" *ngIf="!costCenter.presalesClientId"
                  pTooltip="Offered for every presales client" tooltipPosition="top">Shared</span>
          </td>
          <td>
            <span *ngIf="costCenter.serviceGroupName">{{ costCenter.serviceGroupName }}</span>
            <span class="text-muted" *ngIf="!costCenter.serviceGroupName">—</span>
          </td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                *ngIf="canManagePresales && !costCenter.promotedToCostCenterId"
                [icon]="costCenter.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="costCenter.isActive ? 'success' : 'secondary'"
                [text]="true"
                size="small"
                [pTooltip]="costCenter.isActive ? 'Active' : 'Inactive'" tooltipPosition="top"
                (onClick)="toggleActive(costCenter)" />
              <p-button
                *ngIf="canManagePresales"
                icon="pi pi-pencil"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit" tooltipPosition="top"
                (onClick)="showEditDialog(costCenter)" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="5" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No presales cost centers yet</p>
              <p class="empty-description">Click "Add Presales Cost Center" in the header to create your first one.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<!-- ================= Add / Edit dialog ================= -->
<p-dialog
  [visible]="displayDialog"
  (visibleChange)="displayDialog = $event"
  [header]="isEditMode ? 'Edit Presales Cost Center' : 'Add Presales Cost Center'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true">

  <div class="form-dialog-form">
    <div class="form-dialog-container">

      <div class="emp-section-title"><i class="pi pi-wallet"></i> Basic Information</div>

      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedCostCenter.name.trim()">
          <label for="name">Cost Center Name <span class="required-star">*</span></label>
          <input pInputText id="name" [(ngModel)]="selectedCostCenter.name" placeholder="e.g., PS-Digital Banking Pursuit"
            (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedCostCenter.name.trim()">Cost center name is required</small>
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedCostCenter.description" [rows]="2"
            placeholder="What this cost center covers during the pursuit"></textarea>
        </div>
      </div>

      <div class="emp-section-title"><i class="pi pi-sitemap"></i> Assignment</div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="presalesClient">Presales Client</label>
          <p-select id="presalesClient" [(ngModel)]="selectedCostCenter.presalesClientId"
            [options]="clientOptions" optionLabel="label" optionValue="value"
            placeholder="Shared — all clients" [showClear]="true" appendTo="body"
            [filter]="true" filterPlaceholder="Search…" />
          <small class="field-hint">Leave blank to make this a shared cost center offered for every client.</small>
        </div>
        <div class="field">
          <label for="serviceGroup">Service Group</label>
          <p-select id="serviceGroup" [(ngModel)]="selectedCostCenter.serviceGroupId"
            [options]="serviceGroupOptions" optionLabel="label" optionValue="value"
            placeholder="Select service group" [showClear]="true" appendTo="body"
            [filter]="true" filterPlaceholder="Search…" />
        </div>
      </div>

      <div class="form-row" *ngIf="isEditMode">
        <div class="field">
          <div class="checkbox-item">
            <p-checkbox [(ngModel)]="selectedCostCenter.isActive" [binary]="true" inputId="isActive" />
            <label for="isActive" class="checkbox-label">Active — include in the presales project dropdown</label>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save Cost Center" icon="pi pi-check" (onClick)="saveCostCenter()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
